import {IconButton, Tooltip, Typography} from "@material-tailwind/react";
import {PencilIcon} from "@heroicons/react/24/solid";
import {BsCheckSquare, BsXSquare} from "react-icons/bs";
import persianNumberFormat from "../../../helper/PersianNumberFormat";
import {TableHead} from "../../system/thead";
import React, {useState} from "react";


const TABLE_HEAD = ["#", "نام استان", "نام تکمیلی", "پیش‌شماره", "اولویت", "وضعیت", "عملیات"];

export function ProvinceGrid({provinces, setModalOpen, setSelectedRow, setSortBy, sortType, setSortType}) {

  const [selectedHead, setSelectedHead] = useState("#")

  const headMap = {
    "#": "",
    "نام استان": "title",
    "نام تکمیلی": "description",
    "پیش‌شماره": "tel_prefix",
    "اولویت": "order_by",
    "وضعیت": "status",
    "عملیات": "",
  }

  const headSortable = {
    "#": false,
    "نام استان": true,
    "نام تکمیلی": true,
    "پیش‌شماره": true,
    "اولویت": true,
    "وضعیت": true,
    "عملیات": false,
  }

  return (
    <div>
      <table className="mt-4 text-left w-full">
        <TableHead
          tableHead={TABLE_HEAD}
          headSortable={headSortable}
          headMap={headMap}
          sortType={sortType}
          setSortType={setSortType}
          setSortBy={setSortBy}
          selectedHead={selectedHead}
          setSelectedHead={setSelectedHead}
        />
        <tbody className="textCenter">
        {provinces.map(
          ({
             id,
             title,
             description,
             tel_prefix,
             status,
             order_by,
           }, index) => {
            const isLast = index === provinces.length - 1;
            const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

            return (
              <tr key={id}>

                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {persianNumberFormat(index + 1, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {title}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {description}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(tel_prefix)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(order_by)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center ">
                    {
                      status === 'enable' ? <BsCheckSquare color={"green"} size={30}/> :
                        <BsXSquare color={"red"} size={30}/>
                    }
                  </div>
                </td>

                <td className={classes}>
                  <Tooltip content="ویرایش">
                    <IconButton variant="text" className="text-align=right" onClick={() => {
                      setSelectedRow(provinces[index]);
                      setModalOpen(true);
                    }}>
                      <PencilIcon className="h-4 w-4"/>
                    </IconButton>
                  </Tooltip>
                </td>
              </tr>
            );
          },
        )}
        </tbody>
      </table>
    </div>
  );
}